<aside class="fixed bottom-4 right-4 w-50 h-50 rounded-lg shadow-lg z-50">
  <iframe
    title="Talkdesk Embedded"
    src="https://prd-cdn-talkdesk.talkdesk.com/talkdesk-embedded/latest/generic/index.html"
    allow="microphone *"
    frameborder="0"
    (load)="onFrameLoaded()"
    class="w-full h-full"
    #ctiFrame
  ></iframe>
</aside>
